// -----------------------------------------------------------------------
// <copyright file="input-password.component.ts" company="AntemetA">
//     Copyright (c) AntemetA. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------
import { Component, Optional, Inject, Injector, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, } from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-password2',
    templateUrl: './input-password2.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputPassword2Component,
            multi: true,
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputPassword2Component extends InputBase<string> implements OnDestroy
{
    private static identifier: number = 0;
    public typeInput: string = 'password';
    public extra: string = 'fa-eye-slash';
    private showHide: boolean = false;
    private timer: NodeJS.Timeout;

    constructor (
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
            injector: Injector
    )
    {
        super(injector);

        this.fieldId = `input-password2-${InputPassword2Component.identifier++}-id`;
    }

    ngOnDestroy ()
    {
        clearTimeout(this.timer);
    }

    viewPswd ()
    {
        this.showHide = !this.showHide;
        if (this.showHide)
        {
            this.typeInput = 'text';
            this.extra = 'fa-eye';
            this.initiateTimer();
        }
        else
        {
            this.typeInput = 'password';
            this.extra = 'fa-eye-slash';
        }
    }

    private initiateTimer ()
    {
        if (this.timer)
        {
            clearTimeout(this.timer);
        }

        this.timer = setTimeout(() =>
        {
            if (this.showHide)
            {
                this.viewPswd();
            }
        }, 2500);
    }
}
